/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconPlusSkinny16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusSkinny16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 1a1 1 0 0 0-1 1v5H2a1 1 0 0 0 0 2h5v5a1 1 0 1 0 2 0V9h5a1 1 0 1 0 0-2H9V2a1 1 0 0 0-1-1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconPlusSkinny24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusSkinny24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 3a1 1 0 0 0-1 1v7H4a1 1 0 1 0 0 2h7v7a1 1 0 1 0 2 0v-7h7a1 1 0 1 0 0-2h-7V4a1 1 0 0 0-1-1Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconPlusSkinny = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconPlusSkinny(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconPlusSkinny16 {...iconProps} />;
        case '24':
            return <IconPlusSkinny24 {...iconProps} />;
        default:
            return <IconPlusSkinny24 {...iconProps} />;
    }
});
